import { useCallback, useSyncExternalStore } from 'react';

/** Whether a CSS media query matches (false where matchMedia is missing, e.g. jsdom / SSR). */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback((cb: () => void) => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
    const mql = window.matchMedia(query);
    mql.addEventListener?.('change', cb);
    return () => mql.removeEventListener?.('change', cb);
  }, [query]);
  const get = () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false);
  return useSyncExternalStore(subscribe, get, () => false);
}

/** The Studio tab's two-column layout (trends + the right-hand stage) starts at Tailwind's `lg`. */
export const DESKTOP_QUERY = '(min-width: 1024px)';
